<section>
  <!-- for single discussions -->
  @if (selectedDiscussion) {
    <div>
      <!-- header part inlcuding search and list of all entries -->
      <script>
        document.cookie = "csrftoken={{ csrf_token }}";
      </script>

      <button class="backtoHomeButton" (click)="clearSelection()">
        Zur Diskussions-Übersichtsseite
      </button>
      <div class="center">
        <h2>Diskussion zu {{ personName }}, geb. {{ personGebDate }}</h2>
        <input
          type="text"
          placeholder="Suche nach Autor, Betreff oder Inhalt..."
          (input)="filterEntries($event)"
          class="searchInput"
        />
        <div>
          <div class="buttons">
            <button (click)="showPopUp('add', this.entry)">
              Eigenen Beitrag erstellen
            </button>
            <button
              class="backtoHomeButton"
              [routerLink]="['/ancestors']"
              [queryParams]="{ refn: getEncodedRefn() }"
            >
              Zur Stammfolge
            </button>
          </div>
        </div>
      </div>
      <!-- single entry containers -->
      @for (entry of filteredEntries; track entry.id) {
        <div class="entryContainer">
          <h5>{{ entry.author_name }}: {{ entry.title }}</h5>
          <div [innerHTML]="entry.content" class="entryContent"></div>
          <div class="entryImagesContainer">
            @for (image of entry.images; track $index) {
              <div>
                <img
                  (click)="showPopUp('image', image.original)"
                  loading="lazy"
                  [src]="image.thumbnail"
                  alt="Info Image"
                />
              </div>
            }
          </div>
          <div>
            @for (pdf of entry.pdfs; track $index) {
              <div>
                <a [href]="pdf.url" target="_blank" rel="noopener">{{
                  pdf.name
                }}</a>
              </div>
            }
          </div>
          <div class="entryMeta">
            <p>
              <small>Erstellt am: {{ entry.created_at | date: "short" }}</small
              ><br />
              <small
                >Zuletzt bearbeitet:
                {{ entry.updated_at | date: "short" }}</small
              >
            </p>
            <div class="editOrDeleteContainer">
              @if (entry.author === userEmail) {
                <img
                  src="assets/images/edit_24dp_RGBA(100, 16, 32)_FILL0_wght400_GRAD0_opsz24.png"
                  (click)="showPopUp('edit', entry)"
                />
              }
              @if (entry.author === userEmail) {
                <img
                  src="assets\images\delete_24dp_RGBA(100, 16, 32)_FILL0_wght400_GRAD0_opsz24.png"
                  (click)="showPopUp('delete', entry)"
                />
              }
            </div>
          </div>
        </div>
      }
    </div>
  }

  <!-- for all discussions -->
  @else {
    <h2>Diskussionen zur Stammfolge</h2>
    <p>
      Willkommen auf der Diskussionsseite!<br />
      Um eine neue Diskussion zu einer Person aus der Stammfolge zu starten,
      geht bitte zuerst auf die Seite
      <a routerLink="/ancestors" routerLinkActive="active">Stammfolge</a>, wählt
      die entsprechende Person aus, und klickt auf den Button Diskussion in den
      Personeninfos. Nur so können wir sicherstellen, dass es keine doppelte
      Diskussionen gibt und die Zuordnung funktioniert.<br /><br />
      Wenn ihr eine bereits existierende Diskussion auswählen wollt, findet ihr
      diese in der Liste unten (nach Aktualität sortiert) oder könnt über den
      Namen suchen.<br /><br />
      Jeder Nutzer kann auf der jeweiligen Diskussionsseite immer nur seinen
      eigenen Einträge bearbeiten oder löschen. Sollten euch Beiträge auffallen,
      die problematisch sind, informiert uns bitte.
    </p>
    <div class="searchContainer">
      <input
        type="text"
        placeholder="Suche nach Person..."
        (input)="filterList($event)"
        class="searchInput"
      />
    </div>
    <h3>Vorhandene Diskussionen</h3>
    <ul>
      @for (discussion of filteredDiscussions; track discussion.id) {
        <li (click)="goToDiscussion(discussion.person.id)">
          Diskussion zu Person: {{ discussion.person.id }} -
          {{ discussion.person.name }} - Stand
          {{ discussion.updated_at | date: "short" }}
        </li>
      }
    </ul>
  }
  <!-- PopUp container for all popups on this site -->
  <div
    id="popUpContainer"
    class="popUpInfoContainer dNone"
    (click)="hidePopUp()"
  >
    <!-- PopUp box for adding or editing an entry -->
    @if (entry) {
      <div id="popUp" class="editEntry" (click)="$event.stopPropagation()">
        <form (ngSubmit)="saveEntry()" enctype="multipart/form-data">
          <div class="entryHeader">
            <h5>
              {{ entry.id ? "Beitrag bearbeiten" : "Neuen Beitrag erstellen" }}
            </h5>
            <h5>Titel:</h5>
            <input
              class="entryInput"
              type="text"
              placeholder="Betreff"
              [(ngModel)]="entry.title"
              name="title"
            />
          </div>

          <div>
            <h5>Inhalt (bitte ausfüllen):</h5>
            <quill-editor
              [(ngModel)]="entry.content"
              name="content"
              placeholder="Dein Beitrag"
            ></quill-editor>
          </div>

          <div>
            <div class="divider"></div>
            <h4>Bilder:</h4>
            <h5>Vorhandene Bilder</h5>
            <div class="deleteImageContainer">
              @for (image of entry.images; track $index) {
                <div class="deleteImage">
                  <img
                    [src]="image.thumbnail"
                    alt="Image"
                    width="100"
                    [ngClass]="{
                      'grayed-out': isImageDeleted(image.original, entry),
                    }"
                  />
                  <button
                    type="button"
                    (click)="removeImageByUrl(image.original)"
                  >
                    Bild löschen
                  </button>
                </div>
              }
            </div>
            <h5 for="images">Bilder hochladen (max. 4):</h5>
            @for (index of [1, 2, 3, 4]; track index) {
              <div class="image-upload-container">
                @if (isImageSlotAvailable(index)) {
                  <div class="upload-image-field">
                    <input
                      type="file"
                      [id]="'image' + index"
                      (change)="onImageFileChange($event, index)"
                      accept=".jpg,.png"
                    />
                  </div>
                }
              </div>
            }

            @if (imageFiles.length > 0) {
              <div>
                <h5>Neue Bilder:</h5>
                <ul>
                  @for (file of imageFiles; track $index) {
                    <li>{{ file.name }}</li>
                  }
                </ul>
              </div>
            }
          </div>
          <div>
            <div class="divider"></div>
            <h4>PDFs:</h4>

            <!-- Vorhandene PDFs -->
            <h5>Vorhandene PDFs</h5>
            <div class="deletePdfContainer">
              @for (pdf of entry.pdfs; track $index) {
                <div
                  class="deletePdf"
                  [ngClass]="{ 'grayed-out': isPdfDeleted(pdf.url) }"
                >
                  <!-- PDF-Name editierbar -->
                  <span>{{ pdf.name }}</span>

                  <a [href]="pdf.url" target="_blank" rel="noopener">Ansehen</a>

                  <button type="button" (click)="removePdfByUrl(pdf.url)">
                    PDF löschen
                  </button>
                </div>
              }
            </div>

            <!-- Neue PDFs -->
            <h5>Neue PDFs hochladen (max. 4):</h5>
            @for (index of [1, 2, 3, 4]; track index) {
              <div class="pdf-upload-container">
                @if (isPdfSlotAvailable(index)) {
                  <div>
                    <!-- Falls noch kein PDF hochgeladen wurde → Button statt Input -->
                    <div>
                      <input
                        type="file"
                        [id]="'pdf_' + index"
                        (change)="onPdfFileChange($event, index)"
                        accept=".pdf"
                      />
                    </div>
                  </div>
                }
              </div>
            }
            @if (pdfFiles.length > 0) {
              <div>
                <h5>Neue PDFs:</h5>
                <ul>
                  @for (pdf of pdfFiles; track $index; let i = $index) {
                    <li class="newList">
                      {{ pdf.file.name }}
                      <input
                        type="text"
                        [(ngModel)]="pdf.customName"
                        placeholder="andere Namen vergeben"
                      />
                      <button type="button" (click)="removeNewPdf(i)">
                        Entfernen
                      </button>
                    </li>
                  }
                </ul>
              </div>
            }
          </div>
          <div class="divider"></div>

          <div class="buttonContainer">
            <button type="button" (click)="hidePopUp()">Abbrechen</button>
            <button
              type="submit"
              [disabled]="!entry.content || imageFiles.length > 4"
            >
              Beitrag speichern
            </button>
          </div>
        </form>
      </div>
    }

    <!-- PopUp box for showing image -->
    @if (this.showImageUrl) {
      <div class="showImage">
        <img [src]="this.showImageUrl" />
      </div>
    }

    <!-- PopUp box for deleting an entry -->
    @if (entryToDelete) {
      <div class="editEntry" (click)="$event.stopPropagation()">
        <h3>Beitrag löschen</h3>
        <p>Möchtest du diesen Beitrag löschen?</p>
        <div class="buttonContainer">
          <button (click)="hidePopUp()">Abbrechen</button>
          <button (click)="deleteEntry()">Löschen</button>
        </div>
      </div>
    }
  </div>
</section>
<app-scroll-to-top-button></app-scroll-to-top-button>
